type Props = <T>(list: T[], oldIndex: number, newIndex: number) => T[];

const arrayMove: Props = (list, oldIndex, newIndex) => {
  list.splice(newIndex, 0, list.splice(oldIndex, 1)[0]);
  return [...list];
};

export default arrayMove;
